export { CMS_NAV_ITEM as cardSchemasNav } from './card-schemas';
export { CMS_NAV_ITEM as cardProductsNav } from './card-products';
export { CMS_NAV_ITEM as cardsNav } from './cards';
export { CMS_NAV_ITEM as cardReplacementRequestsNav } from './card-replacement-requests';
import { CMS_NAV_ITEM as cardSchemasNav } from './card-schemas';
import { CMS_NAV_ITEM as cardProductsNav } from './card-products';
import { CMS_NAV_ITEM as cardsNav } from './cards';
import { CMS_NAV_ITEM as cardReplacementRequestsNav } from './card-replacement-requests';
/** Ordered registry — first entry is the default `/cms` redirect target. */
export const ALL_CMS_NAV_ITEMS = [
    cardSchemasNav,
    cardProductsNav,
    cardsNav,
    cardReplacementRequestsNav,
];
